import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  invisible: {
    display: "none"
  },
  vimsSearchContainer: {
    width: "100%",
    height: "50px"
  },
  textBox: {
    minWidth: 50,
    maxWidth: 400,
    width: '90%',
    height: 30,
  },
  label: {
    width: "40%",
    margin: "0"
  },
  box: {
    maxHeight: '30px',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  button: {
    width: "10%",
  },
  delete: {
    padding: theme.spacing(1),
    margin: theme.spacing(0.7),
    stroke: theme.palette.grey[600],
    '&:hover': {
      stroke: theme.palette.grey[800],
    },
  },
  dropdown: {
    minWidth: 50,
    maxWidth: 400,
    width: '110%',
    textOverflow: 'ellipsis',
    height: 30,
  },
  flexBox: {
    maxHeight: '30px',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
}));

export default useStyles;
